import { StyleSheet, Platform } from 'react-native';
import { getResponsiveValue } from './breakpoints';
import { colors, typography, shadows, spacing, borderRadius } from './theme';

export const addVenueStyles = StyleSheet.create({
  scrollView: {
    flex: 1,
    width: '100vw',
    minWidth: '100vw',
  },
  formContainer: {
    flex: 1,
    padding: getResponsiveValue({
      mobile: 20,
      tablet: 30,
      laptop: 40,
      desktop: 40
    }),
    maxWidth: getResponsiveValue({
      mobile: '100vw',
      tablet: '90vw',
      laptop: 1200,
      desktop: 1200
    }),
    minWidth: '100vw',
    alignSelf: 'center',
    width: '100%',
    marginTop: getResponsiveValue({
      mobile: 20,
      tablet: 30,
      laptop: 40,
      desktop: 40
    }),
  },
  title: {
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 36,
      tablet: 42,
      laptop: 48,
      desktop: 48
    }),
    color: '#3ba378',
    textAlign: 'center',
    marginBottom: 30,
    textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
    fontWeight: '500',
  },
  section: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    borderRadius: 15,
    padding: getResponsiveValue({
      mobile: 15,
      tablet: 20,
      laptop: 25,
      desktop: 25
    }),
    marginBottom: 20,
    backdropFilter: Platform.OS === 'web' ? 'blur(10px)' : undefined,
    width: '100%',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.1)',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  sectionTitle: {
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 20,
      tablet: 22,
      laptop: 24,
      desktop: 24
    }),
    color: '#3ba378',
    marginBottom: 20,
    textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
    fontWeight: '500',
  },
  inputContainer: {
    marginBottom: 15,
    width: '100%',
  },
  label: {
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 15,
      laptop: 16,
      desktop: 16
    }),
    color: '#ffffff',
    marginBottom: 8,
    fontWeight: '500',
    // textShadow: '0px 1px 1px rgba(255,255,255,0.15)',
  },
  input: {
    backgroundColor: '#1c1c26',
    borderRadius: 8,
    padding: 12,
    color: '#FFFFFF',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 14,
      tablet: 15,
      laptop: 16,
      desktop: 16
    }),
    width: '100%',
    minHeight: 40,
    textAlign: 'center',
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.1)',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      transition: 'all 0.2s ease-in-out',
      ':hover': {
        borderColor: 'rgba(0, 0, 0, 0.2)',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
      },
      ':focus': {
        borderColor: '#208c6a',
        boxShadow: '0 2px 8px rgba(32, 140, 106, 0.2)',
      },
      '::placeholder': {
        color: 'rgba(255, 255, 255, 0.6)',
        textAlign: 'center',
      }
    }),
  },
  multilineInput: {
    minHeight: 100,
    textAlignVertical: 'top',
    padding: 15,
  },
  submitButton: {
    backgroundColor: '#208c6a',
    padding: getResponsiveValue({
      mobile: 15,
      tablet: 16,
      laptop: 18,
      desktop: 18
    }),
    borderRadius: 10,
    alignItems: 'center',
    marginTop: 30,
    width: getResponsiveValue({
      mobile: '100%',
      tablet: '50%',
      laptop: '30%',
      desktop: '30%'
    }),
    alignSelf: 'center',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.3s ease-in-out',
      ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 12px rgba(255, 140, 0, 0.3)',
        backgroundColor: '#ff9f1a',
      }
    }),
  },
  submitButtonText: {
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 17,
      laptop: 18,
      desktop: 18
    }),
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: 1,
    textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
  },
}); 